import React from 'react'
import {IndexRoute} from 'react-router'
import {NotificationsPage} from './NotificationsPage'

export const routes = <IndexRoute component={NotificationsPage} />
